export enum ListGridDataInputDataType {
  Static = 'static',
  Dynamic = 'dynamic'
}
